import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import theme from '@ep/theme';
import React from 'react';
import ContactUsModal from './ContactUsModal';

const ContactUsButton = styled(Button)`
  outline: none;

  ${theme.mediaQueries.mobileAndTablet} {
    height: 2.5rem;
    font-size: ${theme.typography.toRem(14)};
    padding: 0 1rem;
  }
`;

function ContactUs() {
  const [open, setOpen] = React.useState(false);

  function handleOpen() {
    const contactForm = document.getElementById('contact-form');

    if (contactForm) {
      contactForm.scrollIntoView({ block: 'center' });
    } else {
      setOpen(true);
    }
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <>
      <ContactUsButton label="Contact us" onClick={handleOpen} />
      <ContactUsModal open={open} onClose={handleClose} />  
    </>
  );
}

export default ContactUs;
